import { Component, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { CookieServiceService } from './cookie-service.service';
import { UtilisService } from './utilis.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'BranchChange';
  isLoggedIn: boolean = false;
  constructor(private cookieManagerService: CookieServiceService,
    private utilService: UtilisService, private router: Router, private ngZone: NgZone,) {
    this.isLoggedIn = this.cookieManagerService.isTokenValid();
  }
  logout() {
    this.cookieManagerService.clearTokenCookie();
  }
 
  changeOfRoutes() {
    // alert(this.cookieManagerService.getParsedJWTToken())
    if (this.cookieManagerService.getParsedJWTToken()){
      this.isLoggedIn=true;
    }
    else{
      this.isLoggedIn=false;
    }
  } 
}
